import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// Testimonial data
const testimonials = [
  {
    id: 1,
    quote: "TrendVector has completely transformed my trading strategy. The AI-powered insights are incredibly accurate and have helped me make better investment decisions.",
    name: "Sarah Johnson",
    title: "Senior Portfolio Manager",
    avatarInitial: "S"
  },
  {
    id: 2,
    quote: "The real-time market analysis and predictive models are game-changing. I've seen a 40% improvement in my portfolio performance since using TrendVector.",
    name: "Michael Chen",
    title: "Quantitative Analyst",
    avatarInitial: "M"
  },
  {
    id: 3,
    quote: "As a day trader, I need fast, reliable data. TrendVector delivers exactly that with their cutting-edge technology and intuitive interface.",
    name: "Emily Rodriguez",
    title: "Professional Day Trader",
    avatarInitial: "E"
  },
  {
    id: 4,
    quote: "The machine learning algorithms are incredibly sophisticated. TrendVector has given me insights I never would have discovered on my own.",
    name: "David Thompson",
    title: "Investment Advisor",
    avatarInitial: "D"
  },
  {
    id: 5,
    quote: "Finally, a platform that combines technical analysis with AI predictions. TrendVector is the future of stock market analysis.",
    name: "Lisa Wang",
    title: "Financial Analyst",
    avatarInitial: "L"
  },
  {
    id: 6,
    quote: "The accuracy of TrendVector's predictions is remarkable. It's like having a crystal ball for the stock market.",
    name: "Robert Kim",
    title: "Hedge Fund Manager",
    avatarInitial: "R"
  }
];

const TestimonialSwiper = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            What Our <span className="bg-gradient-to-r from-green-600 to-cyan-600 bg-clip-text text-transparent">
            Users
          </span> Say
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Join thousands of traders who trust TrendVector for their investment decisions
          </p>
        </div>

        {/* Swiper Container */}
        <div className="max-w-7xl mx-auto">
          <Swiper
            effect={'coverflow'}
            grabCursor={true}
            centeredSlides={true}
            loop={true}
            slidesPerView={'auto'}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
            pagination={{ clickable: true }}
            navigation={true}
            modules={[EffectCoverflow, Pagination, Navigation]}
            className="testimonial-swiper"
          >
            {testimonials.map((testimonial) => (
              <SwiperSlide key={testimonial.id} className="w-96">
                <div className="bg-white rounded-xl shadow-lg p-8 h-auto transform transition-all duration-300 hover:shadow-xl">
                  {/* Avatar */}
                  <div className="flex justify-center mb-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
                      <span className="text-white text-xl font-bold">
                        {testimonial.avatarInitial}
                      </span>
                    </div>
                  </div>

                  {/* Quote */}
                  <div className="text-center mb-6">
                    <p className="text-gray-700 text-lg leading-relaxed italic">
                      "{testimonial.quote}"
                    </p>
                  </div>

                  {/* Name and Title */}
                  <div className="text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">
                      {testimonial.name}
                    </h4>
                    <p className="text-gray-500 text-sm">
                      {testimonial.title}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* Custom CSS for better styling */}
      <style jsx>{`
        .testimonial-swiper {
          padding: 50px 0;
        }
        
        .testimonial-swiper .swiper-slide {
          transition: all 0.3s ease;
        }
        
        .testimonial-swiper .swiper-slide-active {
          transform: scale(1.05);
        }
        
        .testimonial-swiper .swiper-pagination-bullet {
          background: #3b82f6;
          opacity: 0.5;
        }
        
        .testimonial-swiper .swiper-pagination-bullet-active {
          opacity: 1;
          background: #3b82f6;
        }
        
        .testimonial-swiper .swiper-button-next,
        .testimonial-swiper .swiper-button-prev {
          color: #3b82f6;
          background: white;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        
        .testimonial-swiper .swiper-button-next:after,
        .testimonial-swiper .swiper-button-prev:after {
          font-size: 16px;
          font-weight: bold;
        }
      `}</style>
    </section>
  );
};

export default TestimonialSwiper;
